import {IAdapter} from '@drl/core/api/adapters/i-adapter';
import {ApiService} from '@drl/core/api/api.service';
import {GetAPICommand} from '@drl/core/api/commands';
import {environment} from '@drl/env/environment';

export class VerifyResetPasswordLinkCommand<T> extends GetAPICommand<T> {
  constructor(apiService: ApiService, adapter: IAdapter<T>) {
    super(
      apiService,
      adapter,
      `${environment.userApiUrl}/auth/verify-reset-password-link`,
    );
  }
}
